const requireEnv = (key: string, fallback?: string): string => {
  const value = import.meta.env[key] ?? fallback;
  if (value === undefined) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

export const env = {
  apiBaseUrl: requireEnv('VITE_API_BASE_URL', 'http://localhost:8000'),
  apiUrl: requireEnv('VITE_API_URL', 'http://localhost:8000/api'),
  appName: requireEnv('VITE_APP_NAME', 'ApiLab'),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
